import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Modal, Table } from "antd";
import RenderTable from "components/table";
import { bindActionCreators } from "redux";
import { Creators as ReadersActions } from "store/readers-tags/readers/readers-duck";
import { IDetailsItems, IItems } from "store/readers-tags/readers/readers-model";
import useTranslation from "utils/hooks/useTranslation";
import ColumnsTable from "./columnsTable";
import ExpandedColumns from "./expandedColumnsTable";
import * as S from "./index.styled";

interface IPropsScreenReadersGrid {
  pageIndex?: number;
  items?: Array<IItems>;
  totalItems?: number;
  searchFilter?: string;
  isLoadingTable: boolean;
  visibleDeleteModal?: boolean;
}

interface IDispatchProps {
  readersShowDrawer: () => void;
  readersChangeFieldValue?: (...args) => void;
  readersShowDeleteModal: () => void;
  readersHideDeleteModal: () => void;
  readersRegisterFetchAsync?: (...args) => void;
  readersAntennaFetchByIdAsync?: (...args) => void;
  readersAntennaReaderDeleteByIdAsync: (...args) => void;
}

type IProps = IPropsScreenReadersGrid & IDispatchProps;

const ReadersGrid = ({
  items,
  pageIndex,
  totalItems,
  searchFilter,
  isLoadingTable,
  visibleDeleteModal,
  readersShowDrawer,
  readersShowDeleteModal,
  readersHideDeleteModal,
  readersChangeFieldValue,
  readersRegisterFetchAsync,
  readersAntennaFetchByIdAsync,
  readersAntennaReaderDeleteByIdAsync,
}: IProps) => {
  const expandedColumnsTable = ExpandedColumns();
  const [selectedReader, setSelectedReader] = useState<number | null>(null);

  const CANCEL = useTranslation({ id: "cancel" });
  const CONFIRM = useTranslation({ id: "confirm" });
  const CONFIRMATION_TITLE_DELETE_READER = useTranslation({ id: "confirmation_title_delete_reader" });
  const ASSOCIATED = useTranslation({ id: "associated" });
  const INACTIVE = useTranslation({ id: "is_inactive" });
  const CONFIRMATION_DESCRIPTION_DELETE_READER_1 = useTranslation({ id: "confirmation_description_delete_reader_1" });
  const CONFIRMATION_DESCRIPTION_DELETE_READER_2 = useTranslation({ id: "confirmation_description_delete_reader_2" });
  const AND = useTranslation({ id: "and" });

  useEffect(() => {
    readersRegisterFetchAsync();
  }, [readersRegisterFetchAsync]);

  useEffect(() => {
    if (searchFilter !== "" || searchFilter === null) {
      readersChangeFieldValue("pageIndex", 1);
      readersRegisterFetchAsync();
    }
  }, [searchFilter]);

  const handleTableChange = (pagination) => {
    readersChangeFieldValue("itemsByPage", pagination.pageSize);
    readersChangeFieldValue("pageIndex", pagination.current);
    readersRegisterFetchAsync();
  };

  const expandedRowRender = (record: IItems) => (
    <Table<IDetailsItems> columns={expandedColumnsTable} dataSource={record.antennas} rowKey={(row) => `${record.id}-${row.antennaNumber}`} pagination={false} />
  );

  const handleClickEditReaderAntenna = (id: number) => {
    readersAntennaFetchByIdAsync(id);
    readersShowDrawer();
  };

  const handleClickDeleteReader = (id: number) => {
    setSelectedReader(id);
    readersShowDeleteModal();
  };

  const handleClickConfirmDelete = () => {
    readersAntennaReaderDeleteByIdAsync(selectedReader);
  };

  return (
    <S.ReadersContainer>
      <RenderTable
        columnsTable={ColumnsTable({ handleClickEditReaderAntenna, handleClickDeleteReader })}
        items={items}
        totalItems={totalItems}
        handleTableChange={handleTableChange}
        pageIndex={pageIndex}
        isLoadingTable={isLoadingTable}
        expandable={{ expandedRowRender, defaultExpandedRowKeys: ["0"] }}
      />
      <Modal
        title={CONFIRMATION_TITLE_DELETE_READER}
        maskClosable={false}
        centered
        open={visibleDeleteModal}
        onCancel={() => readersHideDeleteModal()}
        destroyOnClose={true}
        footer={[
          <Button key="cancel" onClick={() => readersHideDeleteModal()}>
            {CANCEL}
          </Button>,
          <Button key="ok" onClick={handleClickConfirmDelete} className="btnExcludeItem">
            {CONFIRM}
          </Button>,
        ]}
      >
        <p>
          {CONFIRMATION_DESCRIPTION_DELETE_READER_1} <strong>{INACTIVE} </strong>
          {AND} <strong>{ASSOCIATED}</strong> {CONFIRMATION_DESCRIPTION_DELETE_READER_2}
        </p>
      </Modal>
    </S.ReadersContainer>
  );
};

const mapDispatchToActions = (dispatch: any) => bindActionCreators({ ...ReadersActions }, dispatch);

const mapStateToProps = (state) => ({
  items: state.Readers.items,
  totalItems: state.Readers.totalItems,
  searchFilter: state.Readers.searchFilter,
  pageIndex: state.Readers.filter.pageIndex,
  isLoadingTable: state.Readers.isLoadingTable,
  itemsByPage: state.Readers.filter.itemsByPage,
  visibleDeleteModal: state.Readers.visibleDeleteModal,
});

export default connect(mapStateToProps, mapDispatchToActions)(ReadersGrid);
